<template>
  <div class="content-wrap">
    <header class="content-header cf">
      <h3>{{ $t('containers.uvvChecks') }}</h3>
      <div class="header-meta">
        <p>
          <Link
            :to="`/company/containers/${container.uuid}/uvv_checks/new`"
            class="button button-green button-small button-round"
            >{{ $t('containers.addUvvCheck') }}</Link
          >
        </p>
      </div>
    </header>
    <div v-if="uvvChecks && uvvChecks.length > 0" class="content-body">
      <Table>
        <template #header>
          <th>{{ $t('containers.uvvCheckPerformedAt') }}</th>
          <th>{{ $t('containers.uvvCheckDueAt') }}</th>
          <th>{{ $t('containers.uvvCheckBadge') }}</th>
          <th>{{ $t('containers.uvvCheckReport') }}</th>
          <th>
            <span class="visually-hidden">{{ $t('meta.actions') }}</span>
          </th>
        </template>
        <template #body>
          <tr v-for="uvvCheck in uvvChecks" :key="uvvCheck.uuid">
            <td>{{ uvvCheck.performed_at_formatted }}</td>
            <td>{{ uvvCheck.date_formatted }}</td>
            <td>
              <ImageComponent
                v-if="uvvCheck.badge"
                :preview="uvvCheck.badge.preview_url"
                :src="uvvCheck.badge.url"
                :alt="$t('containers.uvvCheckBadge')"
              />
            </td>
            <td>
              <a v-if="uvvCheck.doc" :href="uvvCheck.doc" target="_blank" class="items-center"
                ><span>{{ $t('containers.downloadPdf') }}</span> <i class="material-icons">chevron_right</i></a
              >
            </td>
            <td class="table__actions">
              <button class="table__action-button" @click="deleteUvvCheck(uvvCheck)">
                <span class="material-icons">delete</span>
              </button>
            </td>
          </tr>
        </template>
      </Table>
    </div>
  </div>
</template>

<script>
import ImageComponent from '@/components/Image.vue'
import Table from '@/components/Table/index.vue'

import containersApi from '@/api/container'

export default {
  name: 'CompanyContainerUvvChecks',
  inject: ['showPopup'],
  components: {
    ImageComponent,
    Table,
  },
  props: {
    container: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      uvvChecks: [],
    }
  },
  methods: {
    async deleteUvvCheck(uvvCheck) {
      const confirmed = await this.showPopup({
        content: this.$t('containers.deleteUvvCheckConfirmation'),
        type: 'confirm',
      })

      if (confirmed) {
        const result = await containersApi.deleteUvvCheck(this.container.uuid, uvvCheck.uuid)

        if (result.success) {
          this.uvvChecks = this.uvvChecks.filter(item => item.uuid != uvvCheck.uuid)
        }
      } else {
        return
      }
    },
  },
  async created() {
    this.uvvChecks = await containersApi.getUvvChecks(this.container.uuid)
  },
}
</script>
